export const NAME = 'login';

const CONTEXT = 'LOGIN';

const RESET = `${CONTEXT}::RESET`;

const CHANGE = `${CONTEXT}::CHANGE`;
const MOUNT = `${CONTEXT}::MOUNT`;
const UNMOUNT = `${CONTEXT}::UNMOUNT`;

export const ACTION_TYPES = {
  RESET,
  CHANGE,
  MOUNT,
  UNMOUNT,
};
